import {  Routes } from '@angular/router';
import {LoginComponent} from "./shared/auth/login/login.component";
import {AuthGuard} from "./shared/guards/auth/auth.guard";
import {LayoutComponent} from "./shared/layout/layout.component";
import { UserResolver } from './shared/resolver/user-resolver';
import { PreloadAllModules } from '@angular/router';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    resolve: { user: UserResolver },
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'admin',
        resolve: { user: UserResolver },
        loadChildren: () => import('./admin/routes/Admin.module').then(m => m.AdminRoutingModule),
      },
      {
        path: 'company',
        resolve: { user: UserResolver },
        loadChildren: () => import('./company/routes/Company.module').then(m => m.CompanyRoutingModule),
      },
      {
        path: '',
        redirectTo: 'admin',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];




